export { default } from './OfferPromoBanners.vue'
